module.exports = __webpack_public_path__ + "img/tumblr_black.d85d4e60.png";